import { Box, IconButton } from "@mui/material";
import { PictureAsPdf, Description } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

const UploadedFileNote = ({ file, onDelete }) => {
  if (!file || (Array.isArray(file) && file.length === 0)) return null;

  const files = Array.isArray(file) ? file : [file];

  const isImage = (f) => {
    const name = typeof f === "string" ? f : f.name || "";
    return /\.(jpeg|jpg|png|gif)$/i.test(name) || f.type?.startsWith("image/");
  };

  const isPdf = (f) => {
    const name = typeof f === "string" ? f : f.name || "";
    return /\.pdf$/i.test(name) || f.type === "application/pdf";
  };

  const isDoc = (f) => {
    const name = typeof f === "string" ? f : f.name || "";
    return /\.(doc|docx)$/i.test(name);
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
      {files.map((f, index) => {
        const fileName = typeof f === "string" ? f.split("/").pop() : f.name;
        const previewSrc = isImage(f)
          ? typeof f === "string"
            ? f
            : URL.createObjectURL(f)
          : null;

        const handlePreview = () => {
          if (typeof f === "string") {
            window.open(f, "_blank");
          } else {
            const url = URL.createObjectURL(f);
            window.open(url, "_blank");
          }
        };

        return (
          <Box
            key={index}
            sx={{
              width: 80,
              height: 80,
              border: "1px solid #ccc",
              borderRadius: "8px",
              position: "relative",
              overflow: "hidden",
              backgroundColor: "#f9f9f9",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              flexDirection: "column",
            }}
            onClick={handlePreview}
          >
            {/* Delete Button */}
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onDelete && onDelete(f, index);
              }}
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                color: "red",
                backgroundColor: "#fff",
                borderRadius: "50%",
                p: 0.3,
                zIndex: 10,
                "&:hover": { backgroundColor: "#fff" },
              }}
            >
              <DeleteIcon sx={{ fontSize: 12 }} />
            </IconButton>

            {/* Preview or Placeholder */}
            {previewSrc ? (
              <img
                src={previewSrc}
                alt={fileName || `file-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : isPdf(f) ? (
              <PictureAsPdf sx={{ fontSize: 40, color: "#d32f2f" }} />
            ) : isDoc(f) ? (
              <Description sx={{ fontSize: 40, color: "#1976d2" }} />
            ) : (
              <Description sx={{ fontSize: 40, color: "#888" }} />
            )}

            {/* File Name */}
          </Box>
        );
      })}
    </Box>
  );
};

export default UploadedFileNote;
